import { atom } from 'recoil';

export const isNewIncidentModalOpenAtom = atom<boolean>({
  key: 'isNewIncidentModalOpenAtom',
  default: false,
});
